export enum TransferType {
  DEPOSIT = 'deposit',
  WITHDRAWAL = 'withdrawal',
}

export enum DepositType {
  ONE_TIME = 'one-time',
  RECURRING_DEPOSIT = 'recurring-deposit',
}
